import { useMutation } from "@tanstack/react-query";
import { useRawInitData } from "@tma.js/sdk-react";

type Params = {
  holderCommitment: string;
  encryptionPubKey: string;
};

type Response = { success: boolean; id: string };

export const useIssueBlumCertMutation = () => {
  const initData = useRawInitData();
  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BLUM_GUARDIAN_URL}/api/submit`,
        {
          method: "POST",
          body: JSON.stringify({ ...params, initData }),
        }
      );

      const data: Response = await response.json();

      return data;
    },
  });
};
